export default {
  authorised: [
    {
      path: "/objection-request",
      name: "objectionRequest.index",
      component: () => import("@/modules/objectionRequest/views/TableView.vue"),
    },
  ],
};
